import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MaincontainerComponent } from '../../maincontainer/maincontainer.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-generic',
  templateUrl: './iframe-generic.component.html',
  styleUrls: ['./iframe-generic.component.css'],
})
export class IframeGenericComponent {

  title: string = "";
  url: string = "";
  safeUrl:SafeResourceUrl | undefined;

  constructor(private route: ActivatedRoute,private mainCmp: MaincontainerComponent,
    private sanitizer:DomSanitizer
  ) {}

  ngOnInit(){
    this.route.queryParams.subscribe(params =>{
      this.title = params['title'] || this.route.snapshot.data['title'];
      this.url = params['urlIframe'] || this.route.snapshot.data['urlIframe'];
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle(this.title);
    });
  }
}
